import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from "./redux/actions";

import MaterialTable from "material-table";
import AskAlert from "../common/AskAlert";
import history from "../../common/history";
// import moment from "moment";
import {
  SERVER_PATH,
  AXIOS_CONFIG,
  ROLE_VIEWER,
} from "../common/redux/constantes";
import CloseOutProjectModel from "./CloseOutProjectModel";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import InfoIcon from "@material-ui/icons/Info";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

class ListProjects extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    projects: [{ id: "1" }],
    openDeleteAlert: false,
    deleteProjectID: -1,
    openCloseProject: false,
    closeProject: -1,
    cloneProjectID: -1,
    openCloneAlert: false,
    anchorEl: null,
    projectMenu: null,
  };

  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
    this.editProject = this.editProject.bind(this);
    this.showProject = this.showProject.bind(this);
  }

  editProject() {
    if (this.state.projectMenu) this.props.editProject(this.state.projectMenu);

    this.handleCloseMenu();
  }

  showProject() {
    if (this.state.projectMenu) this.props.showProject(this.state.projectMenu);

    this.handleCloseMenu();
  }

  handleClickMenu = (event, project) => {
    this.setState({ anchorEl: event.currentTarget, projectMenu: project });
  };

  handleCloseMenu = () => {
    this.setState({ anchorEl: null, projectMenu: null });
  };

  deleteProject = () => {
    if (this.state.deleteProjectID !== -1) {
      this.props.actions.deleteProject(
        this.tableRef,
        this.state.deleteProjectID
      );
      this.setState({ openDeleteAlert: false });
    }
  };

  cancelDelete = () => {
    this.setState({ openDeleteAlert: false });
  };

  askDeleteProject = () => {
    if (this.state.projectMenu) {
      let projectID = this.state.projectMenu.project;
      this.setState({ openDeleteAlert: true, deleteProjectID: projectID });
    }
    this.handleCloseMenu();
  };

  askCloneProject = (projectID) => {
    this.setState({ openCloneAlert: true, cloneProjectID: projectID });
  };

  cancelClone = () => {
    this.setState({ openCloneAlert: false, cloneProjectID: -1 });
  };

  cloneProject = () => {
    if (this.state.cloneProjectID !== -1) {
      this.props.actions.cloneProject(this.tableRef, this.state.cloneProjectID);
      this.setState({ openCloneAlert: false });
    }
  };

  refreshTable = () => {
    this.tableRef.current && this.tableRef.current.onQueryChange();
  };

  redirectBreakDown(project) {
    history.push("/wbs/" + project.name, { project: project });
  }

  clickCloseOut(project) {
    this.setState({
      closeProject: project.project,
      openCloseProject: true,
      user_role: Number(localStorage.getItem("role")),
    });
  }

  closeCloseProject = () => {
    this.setState({ openCloseProject: false, closeProject: -1 });
    this.tableRef.current && this.tableRef.current.onQueryChange();
  };

  render() {
    let actionButtons = [
      // {
      //   icon: 'delete',
      //   tooltip: 'Delete',
      //   onClick: (event, rowData) => this.askDeleteProject(rowData.project) //this.props.actions.deleteProject(this.tableRef,rowData.project)
      // },{
      //   icon: 'edit',
      //   tooltip: 'Edit',
      //   onClick: (event, rowData) => this.props.editProject(rowData) //this.props.actions.deleteProject(this.tableRef,rowData.project)
      // },
      // {
      //   icon: 'visibility',
      //   tooltip: 'View information',
      //   onClick: (event, rowData) => this.props.showProject(rowData) //this.props.actions.deleteProject(this.tableRef,rowData.project)
      // },
      {
        icon: "launch",
        tooltip: "Work on Project",
        onClick: (event, rowData) => {
          this.redirectBreakDown(rowData);
        },
      },
      (rowData) => ({
        icon: "repeat",
        tooltip:
          rowData.fake_status === 1 && rowData.cloned === 0
            ? "Duplicate Project"
            : "",
        onClick: (event, rowData) => {
          const enabled = rowData.fake_status === 1 && rowData.cloned === 0;
          if (enabled) {
            this.askCloneProject(rowData.project);
          }
        },
        disabled: !(rowData.fake_status === 1 && rowData.cloned === 0),
      }),
      (rowData) => ({
        icon: "offline_pin",
        tooltip: rowData.fake_status < 2 ? "" : "Close Out",
        onClick: (event, rowData) => {
          if (rowData.fake_status >= 2) {
            this.clickCloseOut(rowData);
          }
        },
        disabled: rowData.fake_status < 2,
      }),

      {
        icon: "more_horiz",
        tooltip: "More",
        onClick: (event, rowData) => {
          this.handleClickMenu(event, rowData);
        },
      },
      {
        icon: "refresh",
        tooltip: "Refresh Data",
        isFreeAction: true,
        onClick: (event) => {
          this.tableRef.current && this.tableRef.current.onQueryChange();
        },
      },
    ];

    //Verificamos permisos
    if (Number(localStorage.getItem("role")) === ROLE_VIEWER) {
      actionButtons.splice(0, 2);
      actionButtons.splice(2, 1);
    }
    return (
      <div>
        <MaterialTable
          tableRef={this.tableRef}
          onRowClick={(evt, selectedRow) => {
            evt.target.ondblclick = () => {
              this.redirectBreakDown(selectedRow);
            };
          }}
          options={{
            actionsColumnIndex: 7,
            paging: false,
            search: false,
            maxBodyHeight: "600px",
            headerStyle: {
              backgroundColor: "#fffff",
              color: "black",
              fontSize: "1.05em",
            },
            rowStyle: (rowData) => {
              return {
                backgroundColor:
                  this.state.selectedRow &&
                  this.state.selectedRow.tableData.id === rowData.tableData.id
                    ? "#EEE"
                    : rowData.tableData.id % 2
                    ? "#fff"
                    : "#f9f9fa",
              };
            },
          }}
          title="Projects"
          columns={[
            {
              title: "Name",
              field: "name",
              cellStyle: {
                borderRight: "1px solid #d4d4d4",
              },
            },
            {
              title: "Description",
              field: "description",
              cellStyle: {
                borderRight: "1px solid #d4d4d4",
              },
            },
            {
              title: "Kick Off Date",
              field: "kod",
              cellStyle: {
                borderRight: "1px solid #d4d4d4",
                width: 150,
                maxWidth: 150,
              },
              headerStyle: {
                maxWidth: 150,
                width: 150,
              },
            },
            {
              title: "Completion Date",
              field: "ecd",
              cellStyle: {
                borderRight: "1px solid #d4d4d4",
                width: 150,
                maxWidth: 150,
              },
              headerStyle: {
                maxWidth: 150,
                width: 150,
              },
            },
            {
              title: "Client",
              field: "client_company",
              cellStyle: {
                borderRight: "1px solid #d4d4d4",
              },
            },
            {
              title: "Status",
              field: "fake_status",
              lookup: { 1: "Planning", 2: "Execution", 3: "Closed" },
              cellStyle: {
                borderRight: "1px solid #d4d4d4",
              },
            },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let url = SERVER_PATH + "/projects/getAll";
              fetch(url, AXIOS_CONFIG())
                .then((response) => response.json())
                .then((result) => {
                  // let projectFormat = result.projects.map(o => {
                  //   o.kod = moment(o.kod).format('YYYY-MM-DD')
                  //   o.ecd = moment(o.ecd).format('YYYY-MM-DD')
                  //   return {...o}
                  // })

                  resolve({
                    data: result.projects,
                    page: 0,
                    totalCount: result.projects.length,
                  });
                })
                .catch((err) => {
                  resolve({ data: [], page: 0, totalCount: 0 });
                });
            })
          }
          actions={actionButtons}
        />
        <Menu
          id="simple-menu"
          anchorEl={this.state.anchorEl}
          open={Boolean(this.state.anchorEl)}
          onClose={this.handleCloseMenu}
        >
          <MenuItem onClick={this.showProject}>
            <ListItemIcon>
              <InfoIcon />
            </ListItemIcon>
            <ListItemText style={{ paddingLeft: 0 }} inset primary="Details" />
          </MenuItem>

          <MenuItem onClick={this.editProject}>
            <ListItemIcon>
              <EditIcon />
            </ListItemIcon>
            <ListItemText style={{ paddingLeft: 0 }} inset primary="Edit" />
          </MenuItem>

          <MenuItem onClick={this.askDeleteProject}>
            <ListItemIcon>
              <DeleteIcon />
            </ListItemIcon>
            <ListItemText style={{ paddingLeft: 0 }} inset primary="Delete" />
          </MenuItem>
        </Menu>
        <AskAlert
          openAlert={this.state.openDeleteAlert}
          handleCloseCancel={this.cancelDelete}
          handleCloseOk={this.deleteProject}
          dialogTitle="Delete Project"
          dialogContent="Are you sure to delete this project?"
        />

        <AskAlert
          openAlert={this.state.openCloneAlert}
          handleCloseCancel={this.cancelClone}
          handleCloseOk={this.cloneProject}
          dialogTitle="Clone Project"
          dialogContent="Are you sure to clone this project?"
        />

        <CloseOutProjectModel
          openDialog={this.state.openCloseProject}
          closeDialog={this.closeCloseProject}
          project={this.state.closeProject}
          user_role={this.state.user_role}
        />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { withRef: true }
)(ListProjects);



// WEBPACK FOOTER //
// ./src/features/home/ListProjects.js